import { SETTINGS_ROUTE } from '../../lib/nav';
import type { PageRoute } from '../../page-route';
import { SettingsPage } from './layout';

/**
 * «Настройки» (007 T037): в оболочке приложения, разделы — вложенные адреса (`/settings/sites`, `/settings/sites/:site`,
 * `/settings/alerts`). Пункт меню и разделы — администратору системы (`lib/nav.ts`, `settingsFor`); права на данные
 * проверяет сервер.
 */
export const route: PageRoute = { path: SETTINGS_ROUTE, access: 'authed', Component: SettingsPage };
